import React from 'react'
import styled from 'styled-components'
import { fonts } from '../Components/Styles/common-styles'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 26px 20px 20px 28px;
`
const MainTitle = styled.div`
    font-size:${fonts.extraLargePlusSize};
    padding: 5px;
    list-style: none;
    left: 0px;
    font-weight: 600;
}
`
const SmallTitle = styled.div`
    font-size:${fonts.bigSize};
    padding:18px 0px;
    list-style: none;
    left: 0px;
    font-weight: 600;
}
`
const Text = styled.div`
    font-size:${fonts.largeSize};
    padding: 18px 0px;
    left: 0px;
    font-weight: 400;
}
`
const DotList = styled.li`
    font-size:${fonts.largeSize};
    line-height: 150%;
`

const dotListMockup = [
  {
    title: 'Opi',
    text: ['suunnittelemaan ja toteuttamaan onnistunut tilaisuus',
      'rakentamaan hyvää vuorovaikutusta ja luottamusta yksilöiden ja ryhmien kanssa',
      'valmentamaan, perehdyttämään ja mentoroimaan monipuolisesti',
      'fasilitoimaan tavoitteellisesti',
      'toimimaan kaikissa rooleissa valmentavalla otteella',
      'aidoksi kuuntelijaksi ja keskustelijaksi',
      'vakuuttavaksi ja vaikuttavaksi viestijäksi'
    ]
  },
  {
    title: 'TaitOnlinen käyttöopastus',
    text: ['Tutustu työkaluun',
      'Rakenna toimiva suunnitelma',
      'Hyödynnä toteutuksen tukena',
      'FAQ'
    ]
  },
  {
    title: 'Onnistuneen tilaisuuden suunnittelu ja rakentaminen',
    text: ['Tunne kohderyhmäsi',
      'Aseta tavoitteet viisaasti',
      'Rajaa sisältöä',
      'Huolehdi osallistujien vireystilasta',
      'Rytmitä ja osallista menetelmien avulla',
      'Valitse toimivat työkalut',
      'Huolehdi ajankäytöstä',
      'Piirrä kokonaiskuva tilaisuudesta',
      'Laadi pelisäännöt',
      'Kutsu kohdennetusti',
      'Valmistele tila ja valitse työkalut',
      'Ohjeista muut tilaisuuden vetämiseen osallistuvat'
    ]
  },
  {
    title: 'Onnistumisen ja tuloksellisuuden varmistaminen toteutuksessa',
    text: ['Ole läsnä',
      'Onnistu vuorovaikutuksessa',
      'Johda omaa energiaasi',
      'Ole tilannetajuinen joka hetkessä',
      'Jousta ja improvisoi tarpeen mukaan',
      'Fokusoi kohti tavoitetta',
      'Kommunikoi selkeästi',
      'Auta kysymyksillä',
      'Tee yhteenvetoja',
      'Onnistu kuuntelijana',
      'Ohjaa dialogiin',
      'Vaikuta ja vakuuta viestijänä',
      'Toimi valmentavalla otteella',
      'Valitse toimintatapasi ja roolisi viisaasti',
      'Onnistu valmentajana',
      'Loista mentorina ja perehdyttäjänä',
      'Toimi tavoitteellisena fasilitaattorina'
    ]
  },
  {
    title: 'Yksilön ja ryhmien kasvun sekä kehittymisen tukeminen',
    text: ['Rakenna luottamusta aktiivisesti',
      'Vahvista psykologista turvallisuutta',
      'Johda tunneilmapiiriä',
      'Tue ryhmän kehittymistä',
      'Tasapuolista ja varmista kaikkien mukanaolo',
      'Tue yksilöiden ja ryhmien oppimista',
      'Kasvata itseluottamusta',
      'Keskity vahvuuksiin',
      'Tue kasvun ajattelua',
      'Vie kohti ratkaisuja',
      'Ruoki motivaatiota',
      'Vahvista muutosjoustavuutta',
      'Tue itseohjautuvuutta'
    ]
  },
  {
    title: 'Verkkotyökalut toiminnan tueksi',
    text: ['Tutustu erilaisiin verkkotyökaluihin',
      'Katso ohjeita verkkotyökalujen käyttöönottoon'
    ]
  },
  {
    title: 'Esimerkkisuunnitelmat rakentamisen tueksi',
    text: ['Viikkopalaveri',
      'Tiimin kuukausikokous',
      'Projektin kick-off palaveri',
      'Puolen päivän ideointityöpaja',
      'Työhyvinvointipäivä',
      'Koulutuspäivä',
      'Yksilöcoaching- tapaaminen',
      'Puolen päivän ryhmäcoaching- tapaaminen'
    ]
  }
]

const LearningCenter = () => {
  return (
    <Container>
      <MainTitle>Learning Center</MainTitle>
      <Text>Kehitä osaamistasi edelleen ja onnistu valmennustemme avulla.
        Valmennukset on pilkottu selkeiksi, tiiviiksi paketeiksi niin,
        että sinun on mahdollisimman helppoa valita juuri tässä hetkessä
        sinua eteenpäin vievä osa tai kokonaisuus.</Text>

      {
        dotListMockup.map((item, index) =>
          <div key={index}>
            <SmallTitle>{item.title}</SmallTitle>
            {item.text.map(i => <DotList key={i}>{i}</DotList>)}
          </div>
        )
      }

    </Container>
  )
}

export default LearningCenter
